import gql from 'graphql-tag';

const START_EVENT_DEBUGGING = gql`
  mutation StartEventDebugging {
    startEventDebugging
  }
`;

export default START_EVENT_DEBUGGING;
